/**
 * Mixin providing injection of a journey provided by the JourneyIndex.vue component
 */
export default {
    inject: ['providedJourney'],
    computed: {
        /**
         * @type {JourneyModelBase}
         */
        journey(){
            return this.providedJourney.value;
        }
    }
}